import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { OrderModalProvider } from './contexts/OrderModalContext';
import { TreasureHuntProvider } from './contexts/TreasureHuntContext';

function App() {
  return (
    <BrowserRouter>
      <OrderModalProvider>
        <TreasureHuntProvider>
          <AppRoutes />
        </TreasureHuntProvider>
      </OrderModalProvider>
    </BrowserRouter>
  );
}

export default App;
